export const rtnRegex = /^\d{14}$/;

export const coordenadaRegex =
  /^([-+]?)([\d]{1,2})(((\.)(\d+)(,)))(\s)(([-+]?)([\d]{1,3})((\.)(\d+))?)$/;

export const telefonoRegex = /^2\d{3}-?\d{4}$/;

export const celularRegex = /^[389]\d{3}-?\d{4}$/;

export const correoRegex =
  /^[a-zA-Z](\.?[a-zA-Z0-9_\-])*@[a-zA-Z0-9]+([\._\-]?[a-zA-Z0-9])+\.[a-zA-Z]{2,}$/;

export const dniRegex = /(^\d{13}$)|(^\d{2}-\d{4}-\d{4}-\d{5}$)|(^[A-Z]\d{6}$)/;

export const urlRegex =
  /^[a-z0-9]+([\-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

export const nombrePropioRegex =
  /^([A-ZÑÁÉÍÓÚÜ][a-zñáéíóúü]*\s)+([A-ZÑÁÉÍÓÚ][a-zñáéíóúü]*)$/;

export const twoOrMoreSpaces = /\s{2,}/;
